module.exports = __webpack_public_path__ + "img/DashIcon.918b8032.png";